import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../../hooks/useSEO';
import SchemaOrg from '../../components/feature/SchemaOrg';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

interface Article {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  tags: string[];
  readTime: string;
  image: string;
}

const KnowledgePage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  
  const articles: Article[] = [
    {
      id: 1,
      title: '搬家前30天完整準備清單，讓搬家不再手忙腳亂',
      excerpt: '搬家是一項複雜的工程，提前30天開始準備能讓整個過程更順利。本文為您整理完整的搬家準備時程表，從選擇搬家公司到最後的清潔工作，每個步驟都為您詳細說明。',
      category: 'preparation',
      tags: ['搬家準備', '時程規劃', '清單'],
      readTime: '5分鐘',
      image: 'https://public.readdy.ai/ai/img_res/65fe797ebf6164c9aa69326201a4179c.jpg'
    },
    {
      id: 2,
      title: '專業打包技巧大公開：易碎品這樣包才安全',
      excerpt: '易碎品的打包是搬家中最需要技巧的部分。從餐具、電器到藝術品，不同物品需要不同的包裝方法。掌握這些專業技巧，讓您的寶貴物品在搬家過程中完好無損。',
      category: 'packing',
      tags: ['打包技巧', '易碎品', '包裝材料'],
      readTime: '7分鐘',
      image: 'https://readdy.ai/api/search-image?query=Careful%20hands%20wrapping%20delicate%20dishes%20and%20glassware%20in%20bubble%20wrap%20and%20newspaper%20professional%20packing%20materials%20scattered%20around%20clean%20white%20background%20with%20soft%20natural%20lighting%20showing%20protective%20packaging%20process&width=1200&height=600&seq=move002&orientation=landscape'
    },
    {
      id: 3,
      title: '搬家費用怎麼算？2024年最新計價方式大解析',
      excerpt: '搬家費用包含哪些項目？樓層費、距離費、特殊服務費如何計算？本文詳細解析搬家公司的收費標準，讓您在選擇服務時能精確預估費用，避免額外收費的困擾。',
      category: 'cost',
      tags: ['搬家費用', '計價方式', '預算規劃'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Calculator%20with%20moving%20cost%20breakdown%20chart%20coins%20and%20bills%20professional%20document%20layout%20on%20clean%20desk%20surface%20modern%20business%20style%20with%20clear%20lighting%20showing%20budget%20planning&width=1200&height=600&seq=move003&orientation=landscape'
    },
    {
      id: 4,
      title: '冰箱搬運要注意什麼？家電搬家完全指南',
      excerpt: '家電搬運需要特別的專業技巧，尤其是冰箱、洗衣機等大型家電。從搬運前的準備、搬運過程的注意事項到安裝後的檢查，本文為您詳細說明家電搬運的每個細節。',
      category: 'special-items',
      tags: ['家電搬運', '冰箱', '洗衣機'],
      readTime: '8分鐘',
      image: 'https://readdy.ai/api/search-image?query=Professional%20movers%20carefully%20transporting%20a%20modern%20refrigerator%20with%20protective%20padding%20and%20straps%20clean%20white%20background%20with%20organized%20moving%20equipment%20and%20safety%20gear%20showing%20appliance%20relocation&width=1200&height=600&seq=move004&orientation=landscape'
    },
    {
      id: 5,
      title: '搬家當天流程安排，讓搬家效率提升50%',
      excerpt: '搬家當天的流程安排決定了整個搬家的效率。從早上的準備工作到最後的驗收，每個時間點都有最佳的安排方式。跟著我們的建議，讓您的搬家過程既快速又順利。',
      category: 'preparation',
      tags: ['搬家流程', '效率提升', '時間管理'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Moving%20day%20timeline%20with%20clock%20showing%20different%20phases%20organized%20boxes%20and%20moving%20crew%20working%20efficiently%20bright%20daylight%20streaming%20through%20windows%20showing%20systematic%20relocation%20process&width=1200&height=600&seq=move005&orientation=landscape'
    },
    {
      id: 6,
      title: '搬家紙箱怎麼選？不同物品的包裝箱選擇指南',
      excerpt: '選對紙箱是成功搬家的第一步。書籍、衣物、廚具需要不同大小和強度的紙箱。本文教您如何選擇最適合的包裝材料，既能保護物品又能節省搬運成本。',
      category: 'packing',
      tags: ['紙箱選擇', '包裝材料', '物品分類'],
      readTime: '4分鐘',
      image: 'https://readdy.ai/api/search-image?query=Various%20sizes%20of%20moving%20boxes%20stacked%20neatly%20different%20packing%20materials%20like%20bubble%20wrap%20and%20tape%20arranged%20around%20clean%20organized%20storage%20room%20with%20natural%20lighting%20showing%20packaging%20supplies&width=1200&height=600&seq=move006&orientation=landscape'
    },
    {
      id: 7,
      title: '鋼琴搬運專業指南：樂器搬家的注意事項',
      excerpt: '鋼琴等樂器的搬運需要專業的技術和設備。從立式鋼琴到平台鋼琴，不同類型的樂器有不同的搬運方式。本文分享專業樂器搬運的經驗，確保您的愛琴安全到達新家。',
      category: 'special-items',
      tags: ['鋼琴搬運', '樂器保護', '專業搬運'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Professional%20movers%20carefully%20transporting%20a%20grand%20piano%20with%20protective%20blankets%20and%20specialized%20equipment%20clean%20white%20background%20with%20organized%20moving%20tools%20and%20safety%20straps%20showing%20piano%20relocation&width=1200&height=600&seq=move007&orientation=landscape'
    },
    {
      id: 8,
      title: '搬家保險怎麼保？物品損壞理賠完整說明',
      excerpt: '搬家過程中物品損壞怎麼辦？搬家保險涵蓋哪些項目？理賠程序如何進行？本文詳細說明搬家保險的重要性及理賠流程，讓您的搬家更有保障。',
      category: 'cost',
      tags: ['搬家保險', '理賠流程', '風險管理'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Insurance%20documents%20and%20protection%20shield%20symbol%20with%20moving%20boxes%20professional%20business%20setting%20clean%20desk%20with%20paperwork%20showing%20moving%20insurance%20coverage&width=1200&height=600&seq=move008&orientation=landscape'
    },
    {
      id: 9,
      title: '長途搬家vs短途搬家，選擇重點大不同',
      excerpt: '長途搬家和短途搬家在準備工作、費用計算、物品包裝等方面都有不同的考量。本文比較兩種搬家方式的差異，幫助您選擇最適合的搬家方案。',
      category: 'transportation',
      tags: ['長途搬家', '短途搬家', '搬家選擇'],
      readTime: '7分鐘',
      image: 'https://readdy.ai/api/search-image?query=Long%20distance%20moving%20truck%20on%20highway%20with%20cityscape%20in%20background%20professional%20logistics%20and%20transportation%20concept%20clean%20modern%20style%20with%20blue%20sky%20showing%20relocation%20journey&width=1200&height=600&seq=move009&orientation=landscape'
    },
    {
      id: 10,
      title: '辦公室搬遷規劃：企業搬家的專業建議',
      excerpt: '企業搬遷比家庭搬家更複雜，涉及設備、文件、員工等多方面考量。本文提供辦公室搬遷的完整規劃建議，讓公司業務在搬遷期間不中斷。',
      category: 'preparation',
      tags: ['辦公室搬遷', '企業搬家', '業務連續性'],
      readTime: '8分鐘',
      image: 'https://readdy.ai/api/search-image?query=Modern%20office%20space%20with%20packed%20boxes%20and%20computer%20equipment%20professional%20business%20relocation%20setup%20clean%20organized%20workspace%20showing%20corporate%20moving%20preparation&width=1200&height=600&seq=move010&orientation=landscape'
    },
    {
      id: 11,
      title: '搬家物品清單製作技巧，一個都不能少',
      excerpt: '完整的物品清單是搬家成功的關鍵。如何有效分類物品、標記重要物品、製作詳細清單？本文教您製作專業的搬家物品清單，避免物品遺失。',
      category: 'preparation',
      tags: ['物品清單', '分類整理', '搬家管理'],
      readTime: '4分鐘',
      image: 'https://readdy.ai/api/search-image?query=Detailed%20moving%20checklist%20on%20clipboard%20with%20pen%20organized%20inventory%20list%20clean%20desk%20setup%20professional%20planning%20documents%20showing%20item%20categorization&width=1200&height=600&seq=move011&orientation=landscape'
    },
    {
      id: 12,
      title: '衣物打包收納術：換季搬家的聰明做法',
      excerpt: '衣物是搬家中數量最多的物品之一。如何分類衣物、選擇合適的包裝方式、利用真空袋節省空間？本文分享衣物打包的專業技巧。',
      category: 'packing',
      tags: ['衣物收納', '真空袋', '換季整理'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Neatly%20folded%20clothes%20in%20vacuum%20bags%20and%20organized%20wardrobe%20boxes%20clean%20white%20background%20with%20clothing%20storage%20solutions%20showing%20efficient%20packing%20methods&width=1200&height=600&seq=move012&orientation=landscape'
    },
    {
      id: 13,
      title: '搬家後快速整理術：3天內恢復正常生活',
      excerpt: '搬家後的整理工作往往比搬家本身更累人。如何有效率地拆箱整理、快速找到必需品、建立新家的生活秩序？本文提供搬家後的整理策略。',
      category: 'tips',
      tags: ['搬家後整理', '拆箱技巧', '生活恢復'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Organized%20new%20home%20interior%20with%20unpacked%20boxes%20and%20arranged%20furniture%20bright%20clean%20living%20space%20showing%20post-move%20organization%20and%20settling%20in%20process&width=1200&height=600&seq=move013&orientation=landscape'
    },
    {
      id: 14,
      title: '植物搬家指南：讓綠色夥伴安全搬新家',
      excerpt: '植物在搬家過程中需要特別的照顧。不同種類的植物有不同的搬運需求，如何包裝、運輸、安置植物？本文為愛植物的您提供專業建議。',
      category: 'special-items',
      tags: ['植物搬運', '園藝搬家', '植物照護'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Potted%20plants%20carefully%20wrapped%20and%20protected%20for%20moving%20green%20houseplants%20in%20boxes%20clean%20bright%20setting%20showing%20plant%20relocation%20care&width=1200&height=600&seq=move014&orientation=landscape'
    },
    {
      id: 15,
      title: '搬家垃圾處理：環保搬家的實用建議',
      excerpt: '搬家過程會產生大量垃圾和不需要的物品。如何環保處理舊物、回收利用包裝材料、減少搬家對環境的影響？本文提供綠色搬家的實踐方法。',
      category: 'transportation',
      tags: ['環保搬家', '垃圾處理', '資源回收'],
      readTime: '4分鐘',
      image: 'https://readdy.ai/api/search-image?query=Recycling%20bins%20and%20eco-friendly%20packing%20materials%20organized%20waste%20sorting%20clean%20green%20environment%20showing%20sustainable%20moving%20practices&width=1200&height=600&seq=move015&orientation=landscape'
    },
    {
      id: 16,
      title: '搬家季節選擇：什麼時候搬家最省錢？',
      excerpt: '選擇合適的搬家時間可以大幅節省費用。淡季搬家、避開高峰期、天氣考量等因素都會影響搬家成本。本文分析各季節搬家的優缺點，幫您找到最划算的搬家時機。',
      category: 'cost',
      tags: ['搬家季節', '費用節省', '時機選擇'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Calendar%20with%20seasonal%20markers%20and%20cost%20comparison%20chart%20professional%20planning%20layout%20showing%20optimal%20moving%20timing%20and%20budget%20considerations&width=1200&height=600&seq=move016&orientation=landscape'
    },
    {
      id: 17,
      title: '新手搬家必知：第一次搬家的完整攻略',
      excerpt: '第一次搬家總是讓人緊張不安。從預算規劃、選擇搬家公司到搬家當天的注意事項，本文為搬家新手提供全方位的指南，讓您的第一次搬家體驗順利愉快。',
      category: 'preparation',
      tags: ['新手搬家', '搬家攻略', '基礎知識'],
      readTime: '8分鐘',
      image: 'https://readdy.ai/api/search-image?query=Beginner-friendly%20moving%20guide%20with%20step-by-step%20instructions%20clean%20organized%20layout%20showing%20first-time%20mover%20preparation%20and%20planning%20materials&width=1200&height=600&seq=move017&orientation=landscape'
    },
    {
      id: 18,
      title: '書籍搬運技巧：重書輕裝的打包秘訣',
      excerpt: '書籍雖小但重量驚人，是搬家中最容易被低估的物品。如何有效打包書籍、選擇合適的箱子、避免箱子過重？本文分享專業的書籍搬運技巧。',
      category: 'packing',
      tags: ['書籍搬運', '重物打包', '箱子選擇'],
      readTime: '4分鐘',
      image: 'https://readdy.ai/api/search-image?query=Books%20neatly%20packed%20in%20small%20sturdy%20boxes%20organized%20library%20packing%20clean%20white%20background%20showing%20proper%20book%20storage%20and%20moving%20techniques&width=1200&height=600&seq=move018&orientation=landscape'
    },
    {
      id: 19,
      title: '搬家糾紛預防：如何避免與搬家公司產生爭議',
      excerpt: '搬家糾紛時有所聞，如何在搬家前做好預防措施？合約條款要注意什麼？物品損壞如何處理？本文教您預防搬家糾紛，保護自己的權益。',
      category: 'preparation',
      tags: ['搬家糾紛', '合約條款', '權益保護'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Contract%20documents%20and%20legal%20protection%20symbols%20professional%20business%20setting%20showing%20moving%20agreement%20and%20consumer%20rights%20protection&width=1200&height=600&seq=move019&orientation=landscape'
    },
    {
      id: 20,
      title: '廚房用品搬家指南：餐具廚具安全搬運術',
      excerpt: '廚房是家中物品最複雜的區域，從鍋碗瓢盆到各種調料，每樣都需要細心處理。本文提供廚房用品的專業打包和搬運方法，確保您的廚具安全抵達新家。',
      category: 'packing',
      tags: ['廚房用品', '餐具打包', '廚具搬運'],
      readTime: '7分鐘',
      image: 'https://readdy.ai/api/search-image?query=Kitchen%20items%20and%20cookware%20carefully%20wrapped%20and%20organized%20clean%20white%20background%20with%20dishes%20pots%20and%20utensils%20showing%20kitchen%20packing%20methods&width=1200&height=600&seq=move020&orientation=landscape'
    },
    {
      id: 21,
      title: '學生搬家省錢攻略：小預算也能搬好家',
      excerpt: '學生族群搬家預算有限，如何在有限的資源下完成搬家？自助搬家、二手紙箱利用、朋友互助等省錢妙招，讓學生也能輕鬆搬家。',
      category: 'transportation',
      tags: ['學生搬家', '省錢搬家', '自助搬家'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Budget-friendly%20student%20moving%20with%20simple%20boxes%20and%20basic%20supplies%20clean%20dorm%20room%20setting%20showing%20affordable%20relocation%20solutions&width=1200&height=600&seq=move021&orientation=landscape'
    },
    {
      id: 22,
      title: '搬家清潔指南：新舊家清潔的完整流程',
      excerpt: '搬家涉及新舊兩個家的清潔工作。舊家需要做好清潔以順利退租，新家也要先清潔再入住。本文提供搬家前後的清潔流程和注意事項。',
      category: 'tips',
      tags: ['搬家清潔', '退租清潔', '入住準備'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Clean%20empty%20room%20with%20cleaning%20supplies%20and%20equipment%20bright%20spotless%20interior%20showing%20professional%20move-out%20cleaning%20preparation&width=1200&height=600&seq=move022&orientation=landscape'
    },
    {
      id: 23,
      title: '寵物搬家安全指南：毛小孩搬家注意事項',
      excerpt: '寵物搬家需要特別的關愛和準備。如何減少寵物的焦慮？怎樣幫助牠們建立安全感？本文提供寵物適應新家的完整指南。',
      category: 'special-items',
      tags: ['寵物搬家', '環境熟悉', '行為訓練'],
      readTime: '7分鐘',
      image: 'https://readdy.ai/api/search-image?query=Happy%20pet%20in%20safe%20carrier%20with%20comfort%20items%20clean%20bright%20setting%20showing%20pet-friendly%20moving%20preparation%20and%20animal%20care&width=1200&height=600&seq=move023&orientation=landscape'
    },
    {
      id: 24,
      title: '搬家打包材料完全指南：選對工具事半功倍',
      excerpt: '好的工具是成功搬家的基礎。氣泡紙、紙箱、膠帶、標籤等各種打包材料該如何選擇？哪些是必需品？哪些可以替代？本文為您詳細解析各種打包材料的使用方法。',
      category: 'packing',
      tags: ['打包材料', '搬家工具', '材料選擇'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Complete%20set%20of%20packing%20materials%20including%20bubble%20wrap%20tape%20boxes%20and%20labels%20organized%20display%20clean%20background%20showing%20moving%20supplies%20collection&width=1200&height=600&seq=move024&orientation=landscape'
    },
    {
      id: 25,
      title: '搬家保護家具：大型家具搬運防護術',
      excerpt: '大型家具是搬家中最容易受損的物品。沙發、床墊、餐桌等家具該如何保護？搬運過程中要注意什麼？本文分享專業的家具保護和搬運技巧。',
      category: 'transportation',
      tags: ['家具搬運', '家具保護', '大型物品'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Large%20furniture%20wrapped%20in%20protective%20blankets%20and%20padding%20professional%20moving%20equipment%20clean%20background%20showing%20furniture%20protection%20methods&width=1200&height=600&seq=move025&orientation=landscape'
    },
    {
      id: 26,
      title: '跨縣市搬家規劃：遠距離搬家的專業建議',
      excerpt: '跨縣市搬家比一般搬家更複雜，需要更周密的規劃。從物流安排、時間規劃到費用預估，本文提供跨縣市搬家的完整攻略。',
      category: 'transportation',
      tags: ['跨縣市搬家', '遠距搬家', '物流規劃'],
      readTime: '8分鐘',
      image: 'https://readdy.ai/api/search-image?query=Long%20distance%20moving%20map%20with%20route%20planning%20professional%20logistics%20concept%20showing%20interstate%20relocation%20planning%20and%20coordination&width=1200&height=600&seq=move026&orientation=landscape'
    },
    {
      id: 27,
      title: '搬家時間規劃：如何安排最有效率的搬家日程',
      excerpt: '時間就是金錢，合理的時間規劃能大大提升搬家效率。從準備階段到搬家當天，每個時段都有最佳的安排方式。本文教您制定完美的搬家時間表。',
      category: 'preparation',
      tags: ['時間規劃', '搬家日程', '效率管理'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Detailed%20timeline%20schedule%20with%20moving%20phases%20organized%20planning%20chart%20clean%20professional%20layout%20showing%20time%20management%20strategy&width=1200&height=600&seq=move027&orientation=landscape'
    },
    {
      id: 28,
      title: '搬家後收納整理：新家物品歸位的智慧方法',
      excerpt: '搬到新家後，如何快速整理物品讓生活步入正軌？收納規劃、空間配置、物品分類都有學問。本文分享搬家後的收納整理技巧，讓新家井然有序。',
      category: 'preparation',
      tags: ['收納整理', '空間規劃', '新家布置'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Well-organized%20new%20home%20interior%20with%20smart%20storage%20solutions%20clean%20modern%20space%20showing%20efficient%20home%20organization%20and%20arrangement&width=1200&height=600&seq=move028&orientation=landscape'
    },
    {
      id: 29,
      title: '雨天搬家應對策略：惡劣天氣的搬家技巧',
      excerpt: '遇到下雨天搬家該怎麼辦？如何保護物品不被淋濕？雨天搬家需要準備哪些防護措施？本文教您在惡劣天氣下也能順利完成搬家。',
      category: 'preparation',
      tags: ['雨天搬家', '天氣應對', '防水保護'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Waterproof%20covered%20boxes%20and%20rain%20protection%20equipment%20professional%20weather-resistant%20moving%20setup%20showing%20rainy%20day%20moving%20preparation&width=1200&height=600&seq=move029&orientation=landscape'
    },
    {
      id: 30,
      title: '搬家風水指南：入宅吉日與注意事項',
      excerpt: '傳統習俗中，搬家入宅有許多講究。如何選擇良辰吉日？入宅當天有哪些儀式？本文介紹搬家風水的基本知識，讓您搬得安心。',
      category: 'preparation',
      tags: ['搬家風水', '入宅吉日', '傳統習俗'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20calendar%20with%20auspicious%20dates%20cultural%20symbols%20and%20feng%20shui%20elements%20showing%20moving%20day%20selection%20and%20customs&width=1200&height=600&seq=move030&orientation=landscape'
    },
    {
      id: 31,
      title: '電器拆裝指南：冷氣、洗衣機專業拆裝流程',
      excerpt: '冷氣、洗衣機等電器的拆裝需要專業技術。自己拆裝有哪些風險？找專業師傅要注意什麼？本文詳細說明電器拆裝的流程和注意事項。',
      category: 'special-items',
      tags: ['電器拆裝', '冷氣安裝', '專業服務'],
      readTime: '7分鐘',
      image: 'https://readdy.ai/api/search-image?query=Professional%20technician%20installing%20air%20conditioner%20and%20appliances%20clean%20workspace%20with%20tools%20showing%20expert%20appliance%20installation%20service&width=1200&height=600&seq=move031&orientation=landscape'
    },
    {
      id: 32,
      title: '搬家斷捨離：搬家前的物品整理術',
      excerpt: '搬家是斷捨離的最佳時機。如何判斷物品該留該丟？二手物品如何處理？本文教您在搬家前做好物品整理，減少搬運負擔，開啟新生活。',
      category: 'preparation',
      tags: ['斷捨離', '物品整理', '極簡生活'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Organized%20decluttering%20process%20with%20sorted%20items%20donation%20boxes%20clean%20minimalist%20space%20showing%20pre-move%20organization%20and%20simplification&width=1200&height=600&seq=move032&orientation=landscape'
    },
    {
      id: 33,
      title: '搬家網路與水電申請：新家入住前的必辦事項',
      excerpt: '搬入新家前，網路、水電、瓦斯等設施都需要提前申請。各項服務的申請流程是什麼？需要準備哪些文件？本文為您整理完整的申請指南。',
      category: 'preparation',
      tags: ['網路申請', '水電設定', '入住準備'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Utility%20application%20forms%20and%20service%20setup%20documents%20professional%20administrative%20layout%20showing%20home%20services%20activation%20process&width=1200&height=600&seq=move033&orientation=landscape'
    },
    {
      id: 34,
      title: '藝術品與古董搬運：珍貴物品的專業保護',
      excerpt: '藝術品、古董等珍貴物品需要最高規格的保護。專業的包裝材料、溫濕度控制、運輸保險都不可少。本文分享珍貴物品搬運的專業知識。',
      category: 'special-items',
      tags: ['藝術品搬運', '古董保護', '高價值物品'],
      readTime: '8分鐘',
      image: 'https://readdy.ai/api/search-image?query=Valuable%20artwork%20and%20antiques%20carefully%20wrapped%20in%20museum-quality%20protection%20materials%20professional%20conservation%20setup%20showing%20precious%20item%20handling&width=1200&height=600&seq=move034&orientation=landscape'
    },
    {
      id: 35,
      title: '搬家地址變更通知：不可遺漏的重要手續',
      excerpt: '搬家後需要通知哪些單位地址變更？銀行、保險、政府機關等重要通知不能漏。本文整理完整的地址變更清單，避免重要信件遺失。',
      category: 'preparation',
      tags: ['地址變更', '搬家手續', '通知清單'],
      readTime: '4分鐘',
      image: 'https://readdy.ai/api/search-image?query=Address%20change%20notification%20checklist%20with%20official%20documents%20professional%20administrative%20setup%20showing%20change%20of%20address%20procedures&width=1200&height=600&seq=move035&orientation=landscape'
    },
    {
      id: 36,
      title: '搬家收納箱選購指南：投資好用的收納工具',
      excerpt: '好的收納箱可以重複使用多年。塑膠箱、紙箱、真空袋各有優缺點，如何選擇最適合的收納工具？本文提供收納箱選購的專業建議。',
      category: 'packing',
      tags: ['收納箱', '收納工具', '長期使用'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Various%20types%20of%20storage%20containers%20and%20organizing%20boxes%20clean%20display%20showing%20different%20storage%20solutions%20and%20packing%20options&width=1200&height=600&seq=move036&orientation=landscape'
    },
    {
      id: 37,
      title: '搬家前的房屋檢查：避免押金糾紛的關鍵',
      excerpt: '搬家前後的房屋檢查是保護押金的重要步驟。如何記錄房屋狀況？哪些損壞需要修復？本文教您做好房屋檢查，避免退租時的押金糾紛。',
      category: 'preparation',
      tags: ['房屋檢查', '押金保護', '退租準備'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Home%20inspection%20checklist%20with%20camera%20documenting%20room%20condition%20clean%20empty%20apartment%20showing%20move-out%20inspection%20process&width=1200&height=600&seq=move037&orientation=landscape'
    },
    {
      id: 38,
      title: '搬家標籤系統：讓整理效率倍增的秘訣',
      excerpt: '完善的標籤系統能讓搬家後的整理工作事半功倍。如何設計有效的標籤？顏色編碼怎麼用？本文分享專業的標籤系統設計方法。',
      category: 'packing',
      tags: ['標籤系統', '分類管理', '整理效率'],
      readTime: '4分鐘',
      image: 'https://readdy.ai/api/search-image?query=Color-coded%20labeling%20system%20with%20organized%20boxes%20clear%20labels%20and%20markers%20clean%20workspace%20showing%20efficient%20moving%20organization%20method&width=1200&height=600&seq=move038&orientation=landscape'
    },
    {
      id: 39,
      title: '搬家與孩子：如何幫助孩子適應新環境',
      excerpt: '搬家對孩子來說是重大改變。如何減少孩子的焦慮？怎樣幫助他們適應新學校和新朋友？本文提供家長實用的建議，讓全家人都能順利適應新生活。',
      category: 'tips',
      tags: ['親子搬家', '兒童適應', '家庭搬遷'],
      readTime: '7分鐘',
      image: 'https://readdy.ai/api/search-image?query=Happy%20family%20with%20children%20in%20new%20home%20unpacking%20boxes%20together%20bright%20cheerful%20atmosphere%20showing%20family%20moving%20and%20settling%20in&width=1200&height=600&seq=move039&orientation=landscape'
    },
    {
      id: 40,
      title: '搬家車輛選擇：如何挑選適合的搬家車型',
      excerpt: '不同規模的搬家需要不同的車輛。3.5噸、5噸、7噸貨車有什麼差別？如何根據物品數量選擇車型？本文詳細介紹各種搬家車輛的特點。',
      category: 'transportation',
      tags: ['車輛選擇', '貨車類型', '運輸規劃'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Different%20sizes%20of%20moving%20trucks%20comparison%20chart%20professional%20fleet%20display%20clean%20background%20showing%20vehicle%20options%20for%20relocation&width=1200&height=600&seq=move040&orientation=landscape'
    },
    {
      id: 41,
      title: '搬家前的數位備份：重要資料不能遺失',
      excerpt: '搬家前做好數位備份非常重要。照片、文件、影片等珍貴資料該如何備份？雲端還是硬碟？本文教您完整的數位資料保護方法。',
      category: 'preparation',
      tags: ['數位備份', '資料保護', '雲端儲存'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Digital%20backup%20process%20with%20cloud%20storage%20and%20external%20hard%20drive%20modern%20technology%20setup%20showing%20data%20protection%20and%20file%20backup&width=1200&height=600&seq=move041&orientation=landscape'
    },
    {
      id: 42,
      title: '搬家時的貴重物品管理：珠寶現金安全指南',
      excerpt: '貴重物品在搬家時需要特別管理。珠寶、現金、重要文件該如何保管？是隨身攜帶還是委託搬家公司？本文提供貴重物品的安全管理建議。',
      category: 'special-items',
      tags: ['貴重物品', '安全管理', '財物保護'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Secure%20safe%20box%20with%20valuable%20items%20jewelry%20and%20documents%20professional%20security%20setup%20showing%20precious%20belongings%20protection&width=1200&height=600&seq=move042&orientation=landscape'
    },
    {
      id: 43,
      title: '搬家與鄰里關係：如何快速融入新社區',
      excerpt: '搬到新社區後，建立良好的鄰里關係很重要。如何與新鄰居打招呼？參加社區活動的好處？本文分享融入新社區的實用技巧。',
      category: 'tips',
      tags: ['鄰里關係', '社區融入', '新生活'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Friendly%20neighbors%20meeting%20and%20greeting%20in%20residential%20community%20warm%20welcoming%20atmosphere%20showing%20community%20integration%20and%20social%20connection&width=1200&height=600&seq=move043&orientation=landscape'
    },
    {
      id: 44,
      title: '搬家費用怎麼算？2024年最新計價方式大解析',
      excerpt: '搬家費用包含哪些項目？樓層費、距離費、特殊服務費如何計算？本文詳細解析搬家公司的收費標準，讓您在選擇服務時能精確預估費用，避免額外收費的困擾。',
      category: 'cost',
      tags: ['搬家費用', '計價方式', '預算規劃'],
      readTime: '7分鐘',
      image: 'https://readdy.ai/api/search-image?query=Calculator%20with%20moving%20cost%20breakdown%20chart%20coins%20and%20bills%20professional%20document%20layout%20on%20clean%20desk%20surface%20modern%20business%20style%20with%20clear%20lighting%20showing%20budget%20planning&width=1200&height=600&seq=move044&orientation=landscape'
    },
    {
      id: 45,
      title: '搬家前的家具測量：確保家具能進新家',
      excerpt: '大型家具能否通過新家的門窗？樓梯轉角夠不夠寬？搬家前的測量工作不可少。本文教您如何正確測量家具和空間尺寸。',
      category: 'preparation',
      tags: ['家具測量', '空間規劃', '尺寸確認'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Person%20measuring%20furniture%20and%20doorway%20with%20tape%20measure%20professional%20planning%20setup%20showing%20space%20measurement%20and%20furniture%20fitting&width=1200&height=600&seq=move045&orientation=landscape'
    },
    {
      id: 46,
      title: '搬家時的照明設備處理：燈具拆裝技巧',
      excerpt: '吊燈、壁燈等照明設備的拆裝需要技巧。如何安全拆卸燈具？燈泡和配件如何包裝？本文提供照明設備搬運的完整指南。',
      category: 'special-items',
      tags: ['燈具拆裝', '照明設備', '電器處理'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Chandelier%20and%20lighting%20fixtures%20carefully%20packed%20and%20protected%20professional%20electrical%20equipment%20handling%20showing%20light%20fixture%20relocation&width=1200&height=600&seq=move046&orientation=landscape'
    },
    {
      id: 47,
      title: '搬家物流追蹤：掌握物品運送進度',
      excerpt: '現代搬家服務提供物流追蹤功能。如何使用GPS追蹤系統？運送過程中如何與司機聯繫？本文介紹搬家物流追蹤的使用方法。',
      category: 'transportation',
      tags: ['物流追蹤', 'GPS系統', '運送管理'],
      readTime: '4分鐘',
      image: 'https://readdy.ai/api/search-image?query=GPS%20tracking%20system%20on%20smartphone%20showing%20moving%20truck%20location%20modern%20technology%20interface%20displaying%20real-time%20delivery%20tracking&width=1200&height=600&seq=move047&orientation=landscape'
    },
    {
      id: 48,
      title: '搬家前的水電瓦斯處理：避免額外費用',
      excerpt: '搬家前後的水電瓦斯如何處理？何時停用舊家？何時啟用新家？處理不當可能產生額外費用。本文提供完整的水電瓦斯處理流程。',
      category: 'preparation',
      tags: ['水電處理', '瓦斯申請', '公用事業'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Utility%20meters%20and%20service%20application%20forms%20professional%20administrative%20setup%20showing%20water%20electricity%20and%20gas%20service%20management&width=1200&height=600&seq=move048&orientation=landscape'
    },
    {
      id: 49,
      title: '搬家紙箱回收再利用：環保又省錢',
      excerpt: '搬家後的紙箱該如何處理？回收、轉賣還是留著備用？本文分享紙箱回收再利用的方法，既環保又能節省下次搬家的成本。',
      category: 'packing',
      tags: ['紙箱回收', '環保搬家', '資源再利用'],
      readTime: '4分鐘',
      image: 'https://readdy.ai/api/search-image?query=Flattened%20cardboard%20boxes%20stacked%20for%20recycling%20clean%20organized%20space%20showing%20eco-friendly%20box%20disposal%20and%20reuse&width=1200&height=600&seq=move049&orientation=landscape'
    },
    {
      id: 50,
      title: '搬家時的床墊處理：大型寢具搬運秘訣',
      excerpt: '床墊體積大又笨重，是搬家中的難題之一。如何保護床墊不弄髒？怎樣搬運最省力？本文分享床墊搬運的專業技巧。',
      category: 'transportation',
      tags: ['床墊搬運', '寢具處理', '大型物品'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Mattress%20wrapped%20in%20protective%20plastic%20cover%20professional%20moving%20equipment%20clean%20background%20showing%20bed%20and%20bedding%20relocation&width=1200&height=600&seq=move050&orientation=landscape'
    },
    {
      id: 51,
      title: '搬家前的冰箱清理：食物處理完全指南',
      excerpt: '搬家前如何處理冰箱裡的食物？哪些可以帶走？哪些要丟棄？本文提供冰箱清理和食物處理的實用建議，避免浪費。',
      category: 'packing',
      tags: ['冰箱清理', '食物處理', '搬家準備'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Clean%20empty%20refrigerator%20with%20food%20items%20organized%20for%20moving%20fresh%20produce%20and%20containers%20showing%20fridge%20preparation%20for%20relocation&width=1200&height=600&seq=move051&orientation=landscape'
    },
    {
      id: 52,
      title: '搬家時的窗簾處理：布藝用品搬運技巧',
      excerpt: '窗簾、地毯等布藝用品該如何打包？需要清洗嗎？如何避免皺摺？本文分享布藝用品的搬運和保養方法。',
      category: 'packing',
      tags: ['窗簾搬運', '布藝用品', '軟裝處理'],
      readTime: '4分鐘',
      image: 'https://readdy.ai/api/search-image?query=Curtains%20and%20fabric%20items%20neatly%20folded%20and%20packed%20clean%20textile%20storage%20showing%20soft%20furnishing%20relocation%20preparation&width=1200&height=600&seq=move052&orientation=landscape'
    },
    {
      id: 53,
      title: '搬家緊急應變：突發狀況處理指南',
      excerpt: '搬家過程中可能遇到各種突發狀況。車輛故障、天氣突變、物品損壞該如何應對？本文提供緊急應變的處理方法。',
      category: 'tips',
      tags: ['緊急應變', '突發狀況', '問題處理'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Emergency%20response%20kit%20with%20first%20aid%20and%20tools%20professional%20preparedness%20setup%20showing%20moving%20day%20emergency%20preparation&width=1200&height=600&seq=move053&orientation=landscape'
    },
    {
      id: 54,
      title: '搬家與風格轉換：新家裝潢規劃建議',
      excerpt: '搬新家是改變居家風格的好機會。如何規劃新家的裝潢？色彩搭配有什麼技巧？本文提供新家裝潢的靈感和建議。',
      category: 'tips',
      tags: ['居家裝潢', '風格規劃', '空間設計'],
      readTime: '7分鐘',
      image: 'https://readdy.ai/api/search-image?query=Modern%20home%20interior%20design%20with%20color%20swatches%20and%20furniture%20layout%20plan%20clean%20stylish%20space%20showing%20home%20decoration%20planning&width=1200&height=600&seq=move054&orientation=landscape'
    },
    {
      id: 55,
      title: '搬家時的鞋子收納：鞋櫃整理打包術',
      excerpt: '鞋子數量多又佔空間，如何有效打包？不同材質的鞋子需要不同保護嗎？本文分享鞋子收納和搬運的專業方法。',
      category: 'packing',
      tags: ['鞋子收納', '鞋櫃整理', '衣物配件'],
      readTime: '4分鐘',
      image: 'https://readdy.ai/api/search-image?query=Shoes%20organized%20in%20boxes%20and%20storage%20containers%20clean%20organized%20closet%20showing%20footwear%20packing%20and%20storage%20solutions&width=1200&height=600&seq=move055&orientation=landscape'
    },
    {
      id: 56,
      title: '搬家時的玩具整理：兒童物品打包指南',
      excerpt: '孩子的玩具又多又雜，如何有效整理？哪些玩具該留哪些要丟？本文提供兒童物品的整理和打包建議，讓搬家成為斷捨離的好機會。',
      category: 'packing',
      tags: ['玩具整理', '兒童物品', '親子收納'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Children%20toys%20organized%20in%20colorful%20storage%20bins%20clean%20playroom%20setup%20showing%20kids%20items%20packing%20and%20organization&width=1200&height=600&seq=move057&orientation=landscape'
    },
    {
      id: 58,
      title: '搬家後的家電設定：快速恢復生活機能',
      excerpt: '搬到新家後，各種家電如何設定？網路、電視、音響系統該怎麼連接？本文提供家電設定的步驟指南，快速恢復生活機能。',
      category: 'special-items',
      tags: ['家電設定', '設備安裝', '生活機能'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Home%20appliances%20being%20set%20up%20and%20connected%20modern%20smart%20home%20devices%20showing%20electronic%20equipment%20installation&width=1200&height=600&seq=move058&orientation=landscape'
    },
    {
      id: 59,
      title: '搬家與極簡生活：打造理想的簡約空間',
      excerpt: '搬家是實踐極簡生活的最佳時機。如何判斷物品的必要性？怎樣建立極簡的生活習慣？本文分享極簡搬家的理念和方法。',
      category: 'preparation',
      tags: ['極簡生活', '斷捨離', '生活哲學'],
      readTime: '7分鐘',
      image: 'https://readdy.ai/api/search-image?query=Minimalist%20home%20interior%20with%20few%20essential%20items%20clean%20spacious%20room%20showing%20simple%20living%20and%20decluttered%20space&width=1200&height=600&seq=move059&orientation=landscape'
    },
    {
      id: 60,
      title: '搬家後的社區探索：認識新環境的方法',
      excerpt: '搬到新社區後，如何快速熟悉周邊環境？哪裡有超市、醫院、學校？本文提供探索新社區的實用建議，幫助您快速適應新生活。',
      category: 'tips',
      tags: ['社區探索', '環境適應', '生活機能'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Neighborhood%20map%20with%20local%20amenities%20marked%20community%20facilities%20and%20services%20showing%20new%20area%20exploration%20and%20orientation&width=1200&height=600&seq=move060&orientation=landscape'
    },
    {
      id: 61,
      title: '夏季搬家攻略：高溫天氣的搬家注意事項',
      excerpt: '夏季是搬家旺季，但高溫天氣帶來許多挑戰。如何在炎熱天氣下安全搬家？本文提供夏季搬家的完整指南，讓您在高溫下也能順利完成搬家。',
      category: 'seasonal',
      tags: ['夏季搬家', '高溫應對', '防暑措施'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Summer%20moving%20scene%20with%20movers%20working%20in%20hot%20weather%20cooling%20equipment%20and%20water%20bottles%20bright%20sunny%20day%20showing%20heat%20protection%20measures%20and%20hydration&width=1200&height=600&seq=move061&orientation=landscape'
    },
    {
      id: 62,
      title: '冬季搬家指南：寒冷天氣的搬家準備',
      excerpt: '冬季搬家雖然是淡季，但寒冷天氣和可能的雨雪需要特別準備。本文分享冬季搬家的注意事項，讓您在寒冬中也能溫暖搬家。',
      category: 'seasonal',
      tags: ['冬季搬家', '保暖措施', '雨雪應對'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Winter%20moving%20preparation%20with%20warm%20clothing%20and%20weather%20protection%20equipment%20cold%20season%20relocation%20showing%20winter%20safety%20measures%20and%20insulation&width=1200&height=600&seq=move062&orientation=landscape'
    },
    {
      id: 63,
      title: '銀髮族搬家指南：長輩搬家的貼心建議',
      excerpt: '長輩搬家需要更多的關懷和協助。從體力考量到情感支持，本文提供銀髮族搬家的完整指南，讓長輩能夠安心、舒適地搬入新家。',
      category: 'tips',
      tags: ['銀髮族搬家', '長輩照護', '無障礙搬家'],
      readTime: '7分鐘',
      image: 'https://readdy.ai/api/search-image?query=Senior-friendly%20moving%20assistance%20with%20careful%20helpers%20and%20elderly%20person%20comfortable%20relocation%20showing%20respectful%20care%20and%20accessibility%20support&width=1200&height=600&seq=move063&orientation=landscape'
    },
    {
      id: 64,
      title: '單身搬家省錢術：一個人也能輕鬆搬家',
      excerpt: '單身族搬家物品較少，如何用最經濟的方式完成搬家？本文分享單身搬家的省錢技巧和自助搬家方法，讓一個人搬家也不是難事。',
      category: 'cost',
      tags: ['單身搬家', '省錢技巧', '自助搬家'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Single%20person%20moving%20with%20minimal%20belongings%20budget-friendly%20setup%20clean%20organized%20space%20showing%20efficient%20solo%20relocation%20and%20cost-saving%20methods&width=1200&height=600&seq=move064&orientation=landscape'
    },
    {
      id: 65,
      title: '新婚夫妻搬家指南：打造甜蜜新家',
      excerpt: '新婚搬家是人生重要時刻，如何規劃新家布置？兩個家庭的物品如何整合？本文提供新婚夫妻搬家的實用建議，開啟幸福新生活。',
      category: 'preparation',
      tags: ['新婚搬家', '新家布置', '物品整合'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Newlywed%20couple%20planning%20new%20home%20together%20with%20moving%20boxes%20and%20decoration%20items%20romantic%20happy%20atmosphere%20showing%20couple%20relocation%20and%20home%20setup&width=1200&height=600&seq=move065&orientation=landscape'
    },
    {
      id: 66,
      title: '台北市搬家攻略：首都搬家的特殊考量',
      excerpt: '台北市人口密集、交通繁忙，搬家有其特殊性。停車問題、電梯預約、社區規定等都需要注意。本文提供台北市搬家的完整攻略。',
      category: 'preparation',
      tags: ['台北搬家', '都市搬家', '停車規劃'],
      readTime: '7分鐘',
      image: 'https://readdy.ai/api/search-image?query=Taipei%20city%20moving%20with%20urban%20apartment%20building%20and%20moving%20truck%20professional%20city%20relocation%20showing%20metropolitan%20moving%20logistics&width=1200&height=600&seq=move066&orientation=landscape'
    },
    {
      id: 67,
      title: '高雄搬家指南：南部搬家的實用建議',
      excerpt: '高雄氣候炎熱、地形特殊，搬家需要考慮不同因素。本文分享高雄地區搬家的注意事項，讓您的南部搬家更順利。',
      category: 'preparation',
      tags: ['高雄搬家', '南部搬家', '氣候考量'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Kaohsiung%20city%20moving%20with%20tropical%20climate%20consideration%20professional%20southern%20Taiwan%20relocation%20showing%20heat-resistant%20moving%20preparation&width=1200&height=600&seq=move067&orientation=landscape'
    },
    {
      id: 68,
      title: '搬家與風水：如何選擇最佳入宅方位',
      excerpt: '除了選擇吉日，入宅方位也很重要。本文介紹搬家風水的基本知識，包括方位選擇、入宅儀式等傳統習俗，讓您搬得安心。',
      category: 'preparation',
      tags: ['搬家風水', '方位選擇', '入宅儀式'],
      readTime: '7分鐘',
      image: 'https://readdy.ai/api/search-image?query=Feng%20shui%20compass%20and%20traditional%20Chinese%20moving%20ceremony%20items%20cultural%20elements%20showing%20auspicious%20direction%20selection%20and%20blessing%20rituals&width=1200&height=600&seq=move068&orientation=landscape'
    },
    {
      id: 69,
      title: '搬家收納神器推薦：提升整理效率的好幫手',
      excerpt: '好的收納工具能讓搬家和整理事半功倍。本文推薦各種實用的收納神器，從真空袋到收納箱，幫助您更有效率地整理物品。',
      category: 'packing',
      tags: ['收納工具', '整理神器', '效率提升'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Various%20storage%20organizers%20and%20packing%20tools%20vacuum%20bags%20containers%20and%20labels%20clean%20display%20showing%20efficient%20organization%20solutions&width=1200&height=600&seq=move069&orientation=landscape'
    },
    {
      id: 70,
      title: '搬家前的數位整理：雲端資料管理術',
      excerpt: '搬家不只是實體物品，數位資料也需要整理。如何管理照片、文件、影片？本文分享數位資料的整理和備份方法。',
      category: 'preparation',
      tags: ['數位整理', '雲端管理', '資料備份'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Digital%20data%20organization%20with%20cloud%20storage%20and%20file%20management%20modern%20technology%20setup%20showing%20digital%20decluttering%20and%20backup%20process&width=1200&height=600&seq=move070&orientation=landscape'
    },
    {
      id: 71,
      title: '搬家與環保：如何實踐綠色搬家',
      excerpt: '環保意識抬頭，搬家也能很環保。從減少包裝材料到回收再利用，本文提供綠色搬家的實踐方法，為地球盡一份心力。',
      category: 'tips',
      tags: ['環保搬家', '綠色生活', '永續發展'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Eco-friendly%20moving%20with%20reusable%20boxes%20and%20sustainable%20materials%20green%20environment%20showing%20environmental%20conscious%20relocation%20practices&width=1200&height=600&seq=move071&orientation=landscape'
    },
    {
      id: 72,
      title: '搬家時的藝術品運輸：畫作雕塑安全指南',
      excerpt: '藝術品、古董等珍貴物品需要特殊處理。溫度控制、避震包裝都很重要。本文教您在搬家時如何安全運輸藝術品。',
      category: 'special-items',
      tags: ['藝術品運輸', '畫作保護', '專業包裝'],
      readTime: '8分鐘',
      image: 'https://readdy.ai/api/search-image?query=Wine%20collection%20carefully%20packed%20in%20specialized%20boxes%20temperature%20controlled%20storage%20showing%20professional%20alcohol%20beverage%20transportation&width=1200&height=600&seq=move076&orientation=landscape'
    },
    {
      id: 77,
      title: '搬家與寵物適應：幫助毛孩融入新環境',
      excerpt: '寵物搬家需要特別的關愛和準備。如何減少寵物的焦慮？怎樣幫助牠們建立安全感？本文提供寵物適應新家的完整指南。',
      category: 'special-items',
      tags: ['寵物搬家', '環境熟悉', '行為訓練'],
      readTime: '7分鐘',
      image: 'https://readdy.ai/api/search-image?query=Happy%20pet%20in%20safe%20carrier%20with%20comfort%20items%20clean%20bright%20setting%20showing%20pet-friendly%20moving%20preparation%20and%20animal%20care&width=1200&height=600&seq=move077&orientation=landscape'
    },
    {
      id: 78,
      title: '搬家時的文件整理：重要資料分類術',
      excerpt: '搬家是整理文件的好時機。如何分類保存重要文件？哪些文件需要長期保存？本文教您建立完善的文件管理系統。',
      category: 'packing',
      tags: ['文件整理', '資料分類', '檔案管理'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Document%20organization%20with%20filing%20system%20and%20labeled%20folders%20professional%20paperwork%20management%20showing%20systematic%20file%20arrangement&width=1200&height=600&seq=move078&orientation=landscape'
    },
    {
      id: 79,
      title: '搬家與室內設計：新家空間規劃指南',
      excerpt: '搬新家是重新規劃空間的機會。如何設計動線？怎樣配置家具？本文提供室內設計的基本原則，幫您打造理想居家空間。',
      category: 'preparation',
      tags: ['室內設計', '空間規劃', '動線配置'],
      readTime: '8分鐘',
      image: 'https://readdy.ai/api/search-image?query=Interior%20design%20planning%20with%20floor%20plan%20and%20furniture%20layout%20modern%20home%20design%20showing%20space%20optimization%20and%20arrangement&width=1200&height=600&seq=move079&orientation=landscape'
    },
    {
      id: 80,
      title: '搬家時的健身器材運輸：大型設備搬運術',
      excerpt: '跑步機、啞鈴架等健身器材又大又重，搬運需要技巧。本文分享健身器材的拆裝和運輸方法，確保設備安全到達新家。',
      category: 'special-items',
      tags: ['健身器材', '大型設備', '拆裝技巧'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Gym%20equipment%20being%20moved%20with%20professional%20handling%20treadmill%20and%20weights%20carefully%20transported%20showing%20fitness%20equipment%20relocation&width=1200&height=600&seq=move080&orientation=landscape'
    },
    {
      id: 81,
      title: '搬家與色彩心理學：選對顏色好心情',
      excerpt: '新家的色彩會影響心情和生活品質。本文介紹色彩心理學在居家設計的應用，幫您選擇最適合的居家色調。',
      category: 'preparation',
      tags: ['色彩心理', '居家配色', '情緒管理'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Color%20palette%20and%20paint%20samples%20for%20home%20decoration%20psychology%20of%20colors%20showing%20interior%20color%20selection%20and%20mood%20enhancement&width=1200&height=600&seq=move081&orientation=landscape'
    },
    {
      id: 82,
      title: '搬家時的衣櫃整理：衣物收納完全攻略',
      excerpt: '搬家是整理衣櫃的最佳時機。如何分類衣物？怎樣規劃衣櫃空間？本文提供完整的衣物收納攻略，讓衣櫃井然有序。',
      category: 'packing',
      tags: ['衣櫃整理', '衣物收納', '空間利用'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Organized%20wardrobe%20with%20neatly%20arranged%20clothes%20efficient%20closet%20system%20showing%20clothing%20storage%20optimization&width=1200&height=600&seq=move084&orientation=landscape'
    },
    {
      id: 85,
      title: '搬家與空氣品質：新家環境檢測指南',
      excerpt: '新家的空氣品質很重要。甲醛、濕度、通風都需要注意。本文介紹如何檢測和改善新家的空氣品質。',
      category: 'preparation',
      tags: ['空氣品質', '環境檢測', '健康居家'],
      readTime: '7分鐘',
      image: 'https://readdy.ai/api/search-image?query=Air%20quality%20testing%20equipment%20and%20ventilation%20system%20clean%20healthy%20home%20environment%20showing%20indoor%20air%20monitoring&width=1200&height=600&seq=move085&orientation=landscape'
    },
    {
      id: 86,
      title: '搬家時的浴室規劃：打造舒適衛浴空間',
      excerpt: '浴室雖小但很重要。如何規劃收納？種什麼植物？本文提供浴室設計的實用建議，打造舒適的私人空間。',
      category: 'preparation',
      tags: ['浴室規劃', '衛浴設計', '收納配置'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Modern%20bathroom%20design%20with%20efficient%20storage%20solutions%20clean%20spa-like%20atmosphere%20showing%20bathroom%20organization%20and%20planning&width=1200&height=600&seq=move086&orientation=landscape'
    },
    {
      id: 87,
      title: '搬家與噪音管理：打造寧靜居家環境',
      excerpt: '噪音會影響生活品質。如何隔音？怎樣選擇安靜的居住環境？本文分享噪音管理的方法，讓新家更寧靜。',
      category: 'preparation',
      tags: ['噪音管理', '隔音設計', '環境品質'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Soundproofing%20materials%20and%20quiet%20home%20environment%20peaceful%20living%20space%20showing%20noise%20reduction%20solutions&width=1200&height=600&seq=move087&orientation=landscape'
    },
    {
      id: 88,
      title: '搬家時的陽台規劃：打造綠意休閒空間',
      excerpt: '陽台是居家的延伸空間。如何規劃陽台？種什麼植物？本文提供陽台設計的創意點子，打造舒適的戶外空間。',
      category: 'preparation',
      tags: ['陽台規劃', '植栽設計', '休閒空間'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20balcony%20garden%20with%20plants%20and%20outdoor%20furniture%20cozy%20relaxation%20space%20showing%20balcony%20design%20and%20greenery&width=1200&height=600&seq=move088&orientation=landscape'
    },
    {
      id: 89,
      title: '搬家與收藏品管理：珍藏物品的整理術',
      excerpt: '郵票、模型、公仔等收藏品需要妥善管理。如何分類展示？怎樣防塵防潮？本文分享收藏品的整理和保存方法。',
      category: 'special-items',
      tags: ['收藏品管理', '展示收納', '保存方法'],
      readTime: '7分鐘',
      image: 'https://readdy.ai/api/search-image?query=Collection%20display%20cabinet%20with%20organized%20collectibles%20professional%20storage%20showing%20hobby%20items%20preservation%20and%20arrangement&width=1200&height=600&seq=move089&orientation=landscape'
    },
    {
      id: 90,
      title: '搬家時的工作室規劃：在家工作空間設計',
      excerpt: '居家辦公越來越普遍，如何在家中規劃工作空間？本文提供工作室設計的建議，打造高效率的居家辦公環境。',
      category: 'preparation',
      tags: ['工作室規劃', '居家辦公', '空間設計'],
      readTime: '7分鐘',
      image: 'https://readdy.ai/api/search-image?query=Home%20office%20workspace%20with%20ergonomic%20furniture%20and%20organized%20desk%20professional%20work%20from%20home%20setup%20showing%20productive%20environment&width=1200&height=600&seq=move090&orientation=landscape'
    },
    {
      id: 91,
      title: '搬家與兒童房設計：打造孩子的成長空間',
      excerpt: '兒童房設計要考慮安全、收納和成長性。本文分享兒童房規劃的要點，為孩子打造安全舒適的成長環境。',
      category: 'preparation',
      tags: ['兒童房設計', '安全規劃', '成長空間'],
      readTime: '7分鐘',
      image: 'https://readdy.ai/api/search-image?query=Colorful%20children%20bedroom%20with%20safe%20furniture%20and%20toy%20storage%20playful%20learning%20space%20showing%20kid-friendly%20room%20design&width=1200&height=600&seq=move091&orientation=landscape'
    },
    {
      id: 92,
      title: '搬家時的書房規劃：打造閱讀學習天地',
      excerpt: '書房是知識的殿堂。如何規劃書櫃？怎樣營造閱讀氛圍？本文提供書房設計的建議，打造舒適的閱讀空間。',
      category: 'preparation',
      tags: ['書房規劃', '閱讀空間', '書櫃設計'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Cozy%20study%20room%20with%20bookshelves%20and%20reading%20nook%20comfortable%20learning%20environment%20showing%20library-style%20home%20office&width=1200&height=600&seq=move092&orientation=landscape'
    },
    {
      id: 93,
      title: '搬家時的寵物用品整理：毛孩物品收納術',
      excerpt: '寵物用品種類繁多，如何整理收納？本文分享寵物用品的分類和收納方法，讓毛孩的東西井然有序。',
      category: 'packing',
      tags: ['寵物用品', '收納整理', '分類管理'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Pet%20supplies%20organized%20in%20storage%20containers%20toys%20food%20and%20accessories%20neatly%20arranged%20showing%20pet%20item%20organization&width=1200&height=600&seq=move093&orientation=landscape'
    },
    {
      id: 94,
      title: '搬家時的運動用品整理：戶外裝備收納指南',
      excerpt: '登山、露營、運動用品如何收納？本文提供運動裝備的整理方法，讓戶外用品保持最佳狀態。',
      category: 'packing',
      tags: ['運動用品', '戶外裝備', '收納方法'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Sports%20equipment%20and%20outdoor%20gear%20organized%20in%20storage%20area%20camping%20and%20hiking%20supplies%20showing%20athletic%20equipment%20organization&width=1200&height=600&seq=move094&orientation=landscape'
    },
    {
      id: 95,
      title: '搬家與手工藝品運輸：DIY作品保護指南',
      excerpt: '手工藝品往往獨一無二且脆弱。如何包裝運輸？本文分享手工藝品的保護方法，確保心血結晶安全抵達。',
      category: 'special-items',
      tags: ['手工藝品', '作品保護', '特殊包裝'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Handmade%20crafts%20carefully%20wrapped%20and%20protected%20delicate%20DIY%20items%20showing%20artisan%20work%20preservation%20and%20transportation&width=1200&height=600&seq=move095&orientation=landscape'
    },
    {
      id: 96,
      title: '搬家時的樂器收藏運輸：音樂器材搬運術',
      excerpt: '除了鋼琴，吉他、小提琴等樂器也需要細心處理。本文介紹各種樂器的包裝和運輸方法，保護您的音樂夥伴。',
      category: 'special-items',
      tags: ['樂器運輸', '音樂器材', '專業包裝'],
      readTime: '7分鐘',
      image: 'https://readdy.ai/api/search-image?query=Musical%20instruments%20in%20protective%20cases%20guitars%20and%20violins%20carefully%20stored%20showing%20instrument%20transportation%20and%20care&width=1200&height=600&seq=move096&orientation=landscape'
    },
    {
      id: 97,
      title: '搬家與攝影器材運輸：相機鏡頭安全指南',
      excerpt: '攝影器材精密且昂貴，運輸需要特別小心。本文提供相機、鏡頭的專業包裝建議，確保器材安全無損。',
      category: 'special-items',
      tags: ['攝影器材', '相機保護', '精密儀器'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Photography%20equipment%20in%20padded%20camera%20bags%20lenses%20and%20cameras%20professionally%20protected%20showing%20photo%20gear%20transportation&width=1200&height=600&seq=move097&orientation=landscape'
    },
    {
      id: 98,
      title: '搬家時的電腦設備整理：3C產品搬運術',
      excerpt: '電腦、螢幕、周邊設備如何打包？線材如何整理？本文分享3C產品的搬運技巧，讓科技產品安全到達新家。',
      category: 'packing',
      tags: ['電腦設備', '3C產品', '線材整理'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Computer%20equipment%20and%20cables%20organized%20for%20moving%20tech%20devices%20carefully%20packed%20showing%20electronics%20relocation%20preparation&width=1200&height=600&seq=move098&orientation=landscape'
    },
    {
      id: 99,
      title: '搬家前的廚具測量：確保家具能進新家',
      excerpt: '大型家具能否通過新家的門窗？樓梯轉角夠不夠寬？搬家前的測量工作不可少。本文教您如何正確測量家具和空間尺寸。',
      category: 'preparation',
      tags: ['家具測量', '空間規劃', '尺寸確認'],
      readTime: '5分鐘',
      image: 'https://readdy.ai/api/search-image?query=Person%20measuring%20furniture%20and%20doorway%20with%20tape%20measure%20professional%20planning%20setup%20showing%20space%20measurement%20and%20furniture%20fitting&width=1200&height=600&seq=move099&orientation=landscape'
    },
    {
      id: 100,
      title: '搬家後的生活適應：建立新生活節奏',
      excerpt: '搬到新家後，如何快速適應新環境？建立新的生活習慣？本文提供搬家後的適應建議，幫您順利展開新生活。',
      category: 'tips',
      tags: ['生活適應', '習慣建立', '新生活'],
      readTime: '6分鐘',
      image: 'https://readdy.ai/api/search-image?query=Happy%20person%20settling%20into%20new%20home%20comfortable%20living%20space%20showing%20successful%20relocation%20adjustment%20and%20new%20life%20beginning&width=1200&height=600&seq=move100&orientation=landscape'
    },
    {
      id: 101,
      title: '2026 搬家打包技巧完整攻略：環保材料與智能包裝新趨勢',
      excerpt: '2026年最新打包技巧指南，涵蓋環保包裝材料、智能標籤系統、分類打包策略。從搬家前4週開始準備，讓您的打包過程更有效率，物品保護更完善。',
      category: 'packing',
      tags: ['2026打包技巧', '環保包裝', '智能搬家', '分類整理'],
      readTime: '12分鐘',
      image: 'https://readdy.ai/api/search-image?query=Modern%20eco-friendly%20packing%20materials%20and%20smart%20labeling%20system%20for%20moving%20in%202026%20sustainable%20packaging%20with%20QR%20codes%20and%20green%20materials%20organized%20workspace%20showing%20innovative%20packing%20solutions&width=1200&height=600&seq=packing2026&orientation=landscape'
    },
    {
      id: 102,
      title: '2026 垃圾清運法規更新完整指南：搬家廢棄物處理新規定',
      excerpt: '2026年台灣垃圾清運法規重大更新，強制分類、智能回收、收費標準全面調整。掌握最新搬家廢棄物處理規定，避免違規罰款，實現環保清運。',
      category: 'preparation',
      tags: ['2026法規更新', '垃圾清運', '環保處理', '搬家廢料'],
      readTime: '10分鐘',
      image: 'https://readdy.ai/api/search-image?query=2026%20Taiwan%20waste%20management%20regulations%20with%20smart%20recycling%20bins%20and%20sorting%20systems%20modern%20environmental%20compliance%20for%20moving%20waste%20disposal%20showing%20updated%20garbage%20collection%20rules&width=1200&height=600&seq=waste2026&orientation=landscape'
    },
    {
      id: 103,
      title: '2026 精緻搬家理賠規範完整指南：保險理賠新制度解析',
      excerpt: '2026年搬家保險理賠制度全面升級，數位化申請流程、AI損害評估、即時理賠成為新趨勢。了解最新理賠規範，保障您的搬家權益。',
      category: 'cost',
      tags: ['2026理賠制度', '搬家保險', '數位理賠', '權益保護'],
      readTime: '11分鐘',
      image: 'https://readdy.ai/api/search-image?query=2026%20digital%20insurance%20claims%20system%20for%20moving%20services%20with%20AI%20assessment%20technology%20and%20mobile%20app%20interface%20modern%20insurance%20protection%20showing%20advanced%20claims%20processing&width=1200&height=600&seq=claims2026&orientation=landscape'
    },
    {
      id: 104,
      title: '搬家前要準備什麼？2026 完整準備清單與時程規劃',
      excerpt: '「搬家前要準備什麼？」這是每個即將搬家的人最常問的問題。本文完整解答搬家前的所有準備工作，從時程規劃、物品整理、到搬家公司選擇，一次告訴您！',
      category: 'preparation',
      tags: ['搬家準備', '搬家清單', '搬家前準備', '搬家攻略'],
      readTime: '15分鐘',
      image: 'https://readdy.ai/api/search-image?query=Professional%20moving%20preparation%20checklist%20with%20calendar%20planner%20boxes%20packing%20supplies%20organized%20on%20clean%20white%20desk%20modern%20minimalist%20style%20bright%20natural%20lighting%20showing%20systematic%20planning%20process&width=1200&height=600&seq=prep-qa-2026&orientation=landscape'
    },
    {
      id: 105,
      title: '搬家公司怎麼選？2026 最完整比較指南與避雷攻略',
      excerpt: '「搬家公司怎麼選？」「哪家搬家公司比較好？」本文教您如何用 10 個關鍵指標選出最適合的搬家公司，避開地雷公司！',
      category: 'tips',
      tags: ['搬家公司推薦', '搬家公司選擇', '搬家公司比較', '搬家公司評價'],
      readTime: '18分鐘',
      image: 'https://readdy.ai/api/search-image?query=Professional%20moving%20company%20team%20with%20modern%20truck%20and%20equipment%20comparing%20services%20checklist%20evaluation%20clean%20bright%20office%20setting%20showing%20reliable%20moving%20service%20selection&width=1200&height=600&seq=choose-company-2026&orientation=landscape'
    },
    {
      id: 106,
      title: '搬家要多少錢？2026 最新費用行情與省錢攻略',
      excerpt: '「搬家要多少錢？」「搬家費用怎麼算？」本文完整解析 2026 年搬家費用行情，教您如何估算搬家預算，以及 10 個省錢技巧！',
      category: 'cost',
      tags: ['搬家費用', '搬家價格', '搬家多少錢', '搬家報價'],
      readTime: '16分鐘',
      image: 'https://readdy.ai/api/search-image?query=Moving%20cost%20calculation%20with%20calculator%20money%20bills%20coins%20and%20moving%20boxes%20on%20clean%20white%20desk%20professional%20budget%20planning%20financial%20document%20showing%20price%20estimation&width=1200&height=600&seq=cost-qa-2026&orientation=landscape'
    },
    {
      id: 107,
      title: '搬家當天要注意什麼？完整流程與必做事項清單',
      excerpt: '「搬家當天要注意什麼？」搬家當天是整個搬家過程中最關鍵的一天。本文完整解析搬家當天的流程、注意事項和必做清單！',
      category: 'preparation',
      tags: ['搬家當天', '搬家注意事項', '搬家流程', '搬家技巧'],
      readTime: '14分鐘',
      image: 'https://readdy.ai/api/search-image?query=Moving%20day%20scene%20with%20professional%20movers%20loading%20furniture%20into%20truck%20organized%20boxes%20labeled%20clearly%20bright%20morning%20sunlight%20showing%20efficient%20relocation%20process&width=1200&height=600&seq=moving-day-2026&orientation=landscape'
    },
    {
      id: 108,
      title: '搬家怎麼省錢？2026 最實用的 15 個省錢技巧大公開',
      excerpt: '「搬家怎麼省錢？」「搬家怎麼省比較快？」本文分享 15 個最實用的搬家省錢技巧，讓您聰明搬家、省錢有方，省下 30-50% 費用！',
      category: 'cost',
      tags: ['搬家省錢', '搬家省錢技巧', '便宜搬家', '搬家預算'],
      readTime: '12分鐘',
      image: 'https://readdy.ai/api/search-image?query=Budget%20saving%20tips%20for%20moving%20with%20piggy%20bank%20coins%20calculator%20and%20moving%20boxes%20on%20clean%20white%20background%20showing%20cost%20reduction%20strategies%20and%20smart%20planning&width=1200&height=600&seq=save-cost-2026&orientation=landscape'
    },
    {
      id: 109,
      title: '如何正確打包易碎品？10步驟完整教學讓碗盤杯子零損壞',
      excerpt: '易碎品是搬家中最容易損壞的物品。本文教您專業的易碎品打包技巧，從材料準備到正確放置，讓您的寶貴物品在搬家過程中完好無損。',
      category: 'packing',
      tags: ['易碎品打包', '打包技巧', '碗盤包裝', '玻璃器皿', 'HowTo教學'],
      readTime: '8分鐘',
      image: 'https://readdy.ai/api/search-image?query=Careful%20hands%20wrapping%20delicate%20dishes%20and%20glassware%20in%20bubble%20wrap%20professional%20packing%20fragile%20items%20clean%20white%20background%20soft%20natural%20lighting%20showing%20protective%20packaging%20process&width=1200&height=600&seq=howto-fragile-001&orientation=landscape'
    },
    {
      id: 110,
      title: '如何拆裝大型家具？衣櫃床架書桌拆裝完整教學',
      excerpt: '大型家具如衣櫃、床架、書桌等，往往因為體積太大無法直接搬運。本文教您如何專業地拆裝各種大型家具，保護家具讓搬運更順利。',
      category: 'special-items',
      tags: ['家具拆裝', '衣櫃拆裝', '床架拆裝', '搬家技巧', 'HowTo教學'],
      readTime: '10分鐘',
      image: 'https://readdy.ai/api/search-image?query=Professional%20furniture%20disassembly%20tools%20screwdriver%20wrench%20organized%20parts%20labeled%20bags%20clean%20workspace%20showing%20systematic%20furniture%20breakdown%20process&width=1200&height=600&seq=howto-furniture-001&orientation=landscape'
    },
    {
      id: 111,
      title: '如何正確搬運冰箱？搬家前後完整處理流程教學',
      excerpt: '冰箱是搬家中最需要特別處理的家電之一。本文教您從搬家前的準備到搬家後的安置，完整的冰箱搬運流程，避免壓縮機損壞。',
      category: 'special-items',
      tags: ['冰箱搬運', '家電搬家', '冰箱處理', '搬家技巧', 'HowTo教學'],
      readTime: '9分鐘',
      image: 'https://readdy.ai/api/search-image?query=Professional%20movers%20carefully%20transporting%20modern%20refrigerator%20with%20protective%20padding%20and%20straps%20clean%20white%20background%20organized%20moving%20equipment%20safety%20gear%20showing%20appliance%20relocation&width=1200&height=600&seq=howto-fridge-001&orientation=landscape'
    },
    {
      id: 112,
      title: '如何製作搬家物品清單？完整分類整理法讓搬家不遺漏',
      excerpt: '完整的搬家物品清單是成功搬家的關鍵。本文教您如何製作專業的搬家物品清單，按房間分類、建立編號系統，讓搬家過程井然有序。',
      category: 'preparation',
      tags: ['搬家清單', '物品整理', '搬家準備', '分類整理', 'HowTo教學'],
      readTime: '7分鐘',
      image: 'https://readdy.ai/api/search-image?query=Detailed%20moving%20checklist%20on%20clipboard%20with%20pen%20organized%20inventory%20list%20clean%20desk%20setup%20professional%20planning%20documents%20showing%20item%20categorization%20systematic%20approach&width=1200&height=600&seq=howto-checklist-001&orientation=landscape'
    },
    {
      id: 113,
      title: '如何選擇搬家公司？10個評估標準找到最適合的搬家服務',
      excerpt: '選擇一家好的搬家公司是成功搬家的關鍵。本文教您10個評估標準，從確認合法性到簽訂合約，幫助您找到專業可靠的搬家公司。',
      category: 'tips',
      tags: ['搬家公司選擇', '搬家公司評估', '搬家服務', '搬家推薦', 'HowTo教學'],
      readTime: '11分鐘',
      image: 'https://readdy.ai/api/search-image?query=Professional%20moving%20company%20team%20with%20modern%20truck%20and%20equipment%20comparing%20services%20checklist%20evaluation%20clean%20bright%20office%20setting%20showing%20reliable%20moving%20service%20selection&width=1200&height=600&seq=howto-company-001&orientation=landscape'
    },
    {
      id: 114,
      title: '如何快速整理搬家後的新家？7天完整整理計畫',
      excerpt: '搬家後的整理工作往往比搬家本身更累人。本文教您如何用7天時間有系統地整理新家，從必需品到裝飾佈置，快速恢復正常生活。',
      category: 'tips',
      tags: ['搬家後整理', '新家整理', '收納技巧', '生活恢復', 'HowTo教學'],
      readTime: '9分鐘',
      image: 'https://readdy.ai/api/search-image?query=Organized%20new%20home%20interior%20with%20unpacked%20boxes%20and%20arranged%20furniture%20bright%20clean%20living%20space%20showing%20post-move%20organization%20and%20settling%20in%20process%20systematic%20approach&width=1200&height=600&seq=howto-organize-001&orientation=landscape'
    },
    {
      id: 115,
      title: '如何節省搬家費用？15個省錢技巧讓搬家預算減半',
      excerpt: '搬家費用是一筆不小的開支，但透過一些技巧可以大幅降低成本。本文分享15個實用省錢技巧，幫助您在不犧牲服務品質的情況下省錢。',
      category: 'cost',
      tags: ['搬家省錢', '搬家費用', '省錢技巧', '搬家預算', 'HowTo教學'],
      readTime: '10分鐘',
      image: 'https://readdy.ai/api/search-image?query=Budget%20saving%20tips%20for%20moving%20with%20piggy%20bank%20coins%20calculator%20and%20moving%20boxes%20on%20clean%20white%20background%20showing%20cost%20reduction%20strategies%20and%20smart%20planning%20financial%20savings&width=1200&height=600&seq=howto-save-001&orientation=landscape'
    }
  ];

  const categoryCounts = useMemo(() => {
    const counts: Record<string, number> = {
      all: 0,
      preparation: 0,
      packing: 0,
      transportation: 0,
      'special-items': 0,
      cost: 0,
      tips: 0,
      seasonal: 0
    };

    articles.forEach(article => {
      counts.all++;
      if (counts[article.category] !== undefined) {
        counts[article.category]++;
      }
    });

    return counts;
  }, []);

  const categories = [
    { 
      id: 'all', 
      name: '全部文章', 
      count: categoryCounts.all, 
      icon: 'ri-file-list-3-line',
      description: '瀏覽所有搬家知識文章',
      color: 'from-teal-500 to-emerald-600'
    },
    { 
      id: 'preparation', 
      name: '搬家準備', 
      count: categoryCounts.preparation, 
      icon: 'ri-checkbox-circle-line',
      description: '搬家前的完整準備指南',
      color: 'from-emerald-500 to-teal-600'
    },
    { 
      id: 'packing', 
      name: '打包技巧', 
      count: categoryCounts.packing, 
      icon: 'ri-box-3-line',
      description: '專業打包方法與技巧',
      color: 'from-amber-500 to-orange-600'
    },
    { 
      id: 'transportation', 
      name: '搬運技巧', 
      count: categoryCounts.transportation, 
      icon: 'ri-truck-line',
      description: '安全搬運與運輸方法',
      color: 'from-cyan-500 to-teal-600'
    },
    { 
      id: 'special-items', 
      name: '特殊物品', 
      count: categoryCounts['special-items'], 
      icon: 'ri-shield-check-line',
      description: '貴重物品專業處理',
      color: 'from-teal-600 to-emerald-700'
    },
    { 
      id: 'cost', 
      name: '費用相關', 
      count: categoryCounts.cost, 
      icon: 'ri-money-dollar-circle-line',
      description: '搬家費用與預算規劃',
      color: 'from-emerald-600 to-green-700'
    },
    { 
      id: 'tips', 
      name: '實用技巧', 
      count: categoryCounts.tips, 
      icon: 'ri-lightbulb-line',
      description: '搬家實用小技巧分享',
      color: 'from-yellow-500 to-amber-600'
    },
    { 
      id: 'seasonal', 
      name: '季節搬家', 
      count: categoryCounts.seasonal, 
      icon: 'ri-sun-line',
      description: '不同季節搬家注意事項',
      color: 'from-lime-500 to-green-600'
    }
  ];

  const filteredArticles = articles.filter(article => {
    const matchesCategory = selectedCategory === 'all' || article.category === selectedCategory;
    const matchesSearch = searchQuery === '' || 
      article.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      article.excerpt.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (article.tags && article.tags.some(tag => tag.toLowerCase().includes(searchQuery.toLowerCase())));
    return matchesCategory && matchesSearch;
  });

  // 精選文章（前3篇）
  const featuredArticles = articles.slice(0, 3);

  return (
    <div className="min-h-screen bg-white">
      <SchemaOrg 
        type="article" 
        data={{
          title: '搬家知識中心 - 專業搬家經驗分享',
          description: '建鈞精緻搬家知識中心，提供100篇專業搬家文章，涵蓋搬家準備、打包技巧、搬運方法、特殊物品處理等全方位搬家知識',
          author: '建鈞精緻搬家編輯團隊',
          category: '搬家知識',
          tags: ['搬家知識', '搬家準備', '打包技巧', '搬運方法', '搬家攻略'],
          wordCount: 50000,
          datePublished: '2024-01-01T00:00:00+08:00',
          dateModified: new Date().toISOString()
        }}
      />
      <SchemaOrg 
        type="howto" 
        data={{
          howToName: '搬家完整準備指南',
          howToDescription: '從搬家前30天開始準備，讓搬家過程更順利的完整步驟指南',
          howToTotalTime: 'P30D',
          howToSteps: [
            {
              name: '選擇搬家公司',
              text: '提前3-7天預約專業搬家公司，比較價格和服務內容'
            },
            {
              name: '整理打包物品',
              text: '將物品分類整理，決定要搬運的物品，進行斷捨離'
            },
            {
              name: '準備包裝材料',
              text: '準備紙箱、氣泡紙、膠帶等包裝材料，妥善包裝物品'
            },
            {
              name: '搬家當天',
              text: '與搬家公司確認細節，監督搬運過程，確保物品安全'
            },
            {
              name: '新家整理',
              text: '拆箱整理物品，快速恢復正常生活'
            }
          ]
        }}
      />

      <Header />

      {/* Hero Section - 使用青綠色系 */}
      <div className="relative bg-gradient-to-br from-teal-600 via-emerald-600 to-teal-700 text-white overflow-hidden">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="absolute inset-0">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-6">
              <i className="ri-book-open-line text-xl"></i>
              <span className="font-medium">專業搬家知識庫</span>
            </div>
            
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              搬家知識中心
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-white/90 max-w-3xl mx-auto">
              100+ 篇專業文章，涵蓋搬家準備、打包技巧、搬運方法等全方位知識
            </p>

            {/* 搜尋框 */}
            <div className="max-w-2xl mx-auto mb-12">
              <div className="relative">
                <input
                  type="text"
                  placeholder="搜尋搬家知識、技巧、注意事項..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full px-6 py-4 pl-14 rounded-2xl text-gray-900 text-lg focus:outline-none focus:ring-4 focus:ring-white/30 shadow-2xl"
                />
                <i className="ri-search-line absolute left-5 top-1/2 -translate-y-1/2 text-2xl text-gray-400"></i>
                {searchQuery && (
                  <button
                    onClick={() => setSearchQuery('')}
                    className="absolute right-5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer"
                  >
                    <i className="ri-close-circle-fill text-2xl"></i>
                  </button>
                )}
              </div>
              {searchQuery && (
                <div className="mt-3 text-white/80 text-sm">
                  找到 {filteredArticles.length} 篇相關文章
                </div>
              )}
            </div>

            {/* 信任指標 */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/20 transition-all">
                <div className="text-4xl font-bold mb-2">100+</div>
                <div className="text-white/80">專業文章</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/20 transition-all">
                <div className="text-4xl font-bold mb-2">8</div>
                <div className="text-white/80">知識分類</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/20 transition-all">
                <div className="text-4xl font-bold mb-2">10+</div>
                <div className="text-white/80">年經驗</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/20 transition-all">
                <div className="text-4xl font-bold mb-2">5000+</div>
                <div className="text-white/80">成功案例</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* 精選文章 */}
        {selectedCategory === 'all' && searchQuery === '' && (
          <div className="mb-20">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                <i className="ri-star-line text-yellow-500 mr-2"></i>
                精選推薦文章
              </h2>
              <p className="text-lg text-gray-600">最受歡迎的搬家知識文章</p>
            </div>
            
            <div className="grid md:grid-cols-3 gap-8">
              {featuredArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/knowledge/article/${article.id}`}
                  className="group cursor-pointer"
                >
                  <div className="relative overflow-hidden rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 bg-white">
                    <div className="relative h-64 overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                      <div className="absolute top-4 left-4">
                        <span className="px-3 py-1 bg-gradient-to-r from-yellow-400 to-orange-500 text-white text-xs font-bold rounded-full shadow-lg flex items-center gap-1">
                          <i className="ri-star-fill"></i>
                          精選推薦
                        </span>
                      </div>
                      <div className="absolute bottom-4 right-4">
                        <span className="px-3 py-1 bg-white/90 backdrop-blur-sm text-gray-700 text-xs font-medium rounded-full flex items-center gap-1">
                          <i className="ri-time-line"></i>
                          {article.readTime}
                        </span>
                      </div>
                    </div>
                    <div className="p-6">
                      <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors line-clamp-2 leading-tight">
                        {article.title}
                      </h3>
                      <p className="text-gray-600 mb-4 line-clamp-2 text-sm">
                        {article.excerpt}
                      </p>
                      <div className="flex items-center justify-between">
                        <span className={`px-3 py-1 bg-gradient-to-r ${categories.find(c => c.id === article.category)?.color} text-white text-xs font-bold rounded-full`}>
                          {categories.find(c => c.id === article.category)?.name}
                        </span>
                        <span className="text-teal-600 font-semibold text-sm group-hover:gap-2 flex items-center gap-1 transition-all whitespace-nowrap">
                          閱讀文章 <i className="ri-arrow-right-line"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            {/* 標籤瀏覽入口 */}
            <div className="mt-12">
              <Link
                to="/knowledge/tags"
                className="block bg-gradient-to-r from-teal-50 to-emerald-50 rounded-3xl p-8 border-2 border-teal-200 hover:border-teal-400 hover:shadow-xl transition-all group"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-6">
                    <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                      <i className="ri-price-tag-3-line text-3xl text-white"></i>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-2 group-hover:text-teal-600 transition-colors">
                        按標籤瀏覽文章
                      </h3>
                      <p className="text-gray-600">
                        透過 50+ 個標籤快速找到您感興趣的搬家知識，包含 AI 口語化問題、打包技巧、費用預算等
                      </p>
                    </div>
                  </div>
                  <div className="hidden md:flex items-center gap-3">
                    <div className="flex flex-wrap gap-2 max-w-md">
                      {['搬家準備', '搬家費用', 'AI口語化問題', '打包技巧', '省錢技巧'].map((tag, index) => (
                        <span key={index} className="px-3 py-1 bg-white text-teal-700 text-sm rounded-full border border-teal-200">
                          #{tag}
                        </span>
                      ))}
                    </div>
                    <i className="ri-arrow-right-line text-3xl text-teal-600 group-hover:translate-x-2 transition-transform"></i>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        )}

        {/* 知識分類卡片 */}
        {selectedCategory === 'all' && searchQuery === '' && (
          <div className="mb-20">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                <i className="ri-folder-open-line text-teal-600 mr-2"></i>
                知識分類導覽
              </h2>
              <p className="text-lg text-gray-600">選擇您感興趣的主題，快速找到需要的資訊</p>
            </div>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {categories.filter(cat => cat.id !== 'all').map((category) => (
                <button
                  key={category.id}
                  onClick={() => setSelectedCategory(category.id)}
                  className="group cursor-pointer text-left"
                >
                  <div className="relative overflow-hidden bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 p-8 border-2 border-transparent hover:border-teal-200">
                    <div className={`absolute top-0 right-0 w-32 h-32 bg-gradient-to-br ${category.color} opacity-10 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-500`}></div>
                    
                    <div className="relative">
                      <div className={`w-16 h-16 bg-gradient-to-br ${category.color} rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
                        <i className={`${category.icon} text-3xl text-white`}></i>
                      </div>
                      
                      <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-600 transition-all">
                        {category.name}
                      </h3>
                      
                      <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                        {category.description}
                      </p>
                      
                      <div className="flex items-center justify-between">
                        <span className="text-2xl font-bold text-teal-600">
                          {category.count}
                          <span className="text-sm text-gray-500 ml-1">篇</span>
                        </span>
                        <span className="text-teal-600 font-semibold text-sm group-hover:gap-2 flex items-center gap-1 transition-all whitespace-nowrap">
                          查看文章 <i className="ri-arrow-right-line"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </button>
              ))}
            </div>

            {/* 標籤瀏覽入口 */}
            <div className="mt-12">
              <Link
                to="/knowledge/tags"
                className="block bg-gradient-to-r from-teal-50 to-emerald-50 rounded-3xl p-8 border-2 border-teal-200 hover:border-teal-400 hover:shadow-xl transition-all group"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-6">
                    <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                      <i className="ri-price-tag-3-line text-3xl text-white"></i>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-2 group-hover:text-teal-600 transition-colors">
                        按標籤瀏覽文章
                      </h3>
                      <p className="text-gray-600">
                        透過 50+ 個標籤快速找到您感興趣的搬家知識，包含 AI 口語化問題、打包技巧、費用預算等
                      </p>
                    </div>
                  </div>
                  <div className="hidden md:flex items-center gap-3">
                    <div className="flex flex-wrap gap-2 max-w-md">
                      {['搬家準備', '搬家費用', 'AI口語化問題', '打包技巧', '省錢技巧'].map((tag, index) => (
                        <span key={index} className="px-3 py-1 bg-white text-teal-700 text-sm rounded-full border border-teal-200">
                          #{tag}
                        </span>
                      ))}
                    </div>
                    <i className="ri-arrow-right-line text-3xl text-teal-600 group-hover:translate-x-2 transition-transform"></i>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        )}

        {/* 分類篩選器（當選擇分類或搜尋時顯示） */}
        {(selectedCategory !== 'all' || searchQuery !== '') && (
          <div className="mb-12">
            <div className="bg-gradient-to-r from-teal-50 to-emerald-50 border-l-4 border-teal-600 p-6 rounded-lg shadow-md">
              <div className="flex flex-wrap gap-3 items-center">
                <span className="text-gray-700 font-bold flex items-center gap-2">
                  <i className="ri-filter-3-line text-teal-600"></i>
                  篩選分類：
                </span>
                {categories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => {
                      setSelectedCategory(category.id);
                      setSearchQuery('');
                    }}
                    className={`px-6 py-3 rounded-full font-medium transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer ${
                      selectedCategory === category.id
                        ? 'bg-gradient-to-r from-teal-600 to-emerald-600 text-white shadow-lg transform scale-105'
                        : 'bg-white text-gray-700 hover:bg-teal-50 hover:text-teal-700 border border-gray-200'
                    }`}
                  >
                    <i className={`${category.icon} text-lg`}></i>
                    <span>{category.name}</span>
                    {selectedCategory === category.id && (
                      <i className="ri-check-line text-lg"></i>
                    )}
                    <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${
                      selectedCategory === category.id
                        ? 'bg-white/20 text-white'
                        : 'bg-teal-100 text-teal-700'
                    }`}>
                      {category.count}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* 搜尋結果提示 */}
        {searchQuery && (
          <div className="mb-8 bg-gradient-to-r from-teal-50 to-emerald-50 border-l-4 border-teal-600 p-6 rounded-lg shadow-md">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-search-line text-2xl text-white"></i>
              </div>
              <div className="flex-1">
                <p className="text-gray-900 font-bold text-lg mb-1">
                  搜尋「{searchQuery}」找到 {filteredArticles.length} 篇文章
                </p>
                <p className="text-gray-600 text-sm">
                  {filteredArticles.length > 0 ? '以下是為您找到的相關文章' : '試試其他關鍵字或瀏覽分類'}
                </p>
              </div>
              <button
                onClick={() => setSearchQuery('')}
                className="px-4 py-2 bg-teal-600 text-white rounded-full text-sm font-medium hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1"
              >
                <i className="ri-close-line"></i>
                清除搜尋
              </button>
            </div>
          </div>
        )}

        {/* 文章列表 */}
        <div>
          {filteredArticles.length > 0 ? (
            <>
              <div className="mb-8 flex items-center justify-between">
                <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
                  <i className="ri-article-line text-teal-600"></i>
                  {selectedCategory === 'all' && !searchQuery ? '所有文章' : 
                   searchQuery ? '搜尋結果' :
                   categories.find(c => c.id === selectedCategory)?.name}
                  <span className="px-4 py-1 bg-teal-100 text-teal-700 rounded-full text-base font-semibold">
                    {filteredArticles.length} 篇
                  </span>
                </h2>
                
                {selectedCategory !== 'all' && !searchQuery && (
                  <button
                    onClick={() => setSelectedCategory('all')}
                    className="text-teal-600 hover:text-teal-700 font-medium text-sm flex items-center gap-1 cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-arrow-left-line"></i>
                    返回全部文章
                  </button>
                )}
              </div>

              <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
                {filteredArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/knowledge/article/${article.id}`}
                    className="group cursor-pointer"
                  >
                    <div className="bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 h-full flex flex-col border border-gray-100 hover:border-teal-200">
                      <div className="relative overflow-hidden h-56">
                        <img
                          src={article.image}
                          alt={article.title}
                          className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                        <div className="absolute top-4 left-4">
                          <span className={`px-3 py-1 bg-gradient-to-r ${categories.find(c => c.id === article.category)?.color} text-white text-xs font-bold rounded-full shadow-lg`}>
                            {categories.find(c => c.id === article.category)?.name}
                          </span>
                        </div>
                        <div className="absolute bottom-4 right-4">
                          <span className="px-3 py-1 bg-white/90 backdrop-blur-sm text-gray-700 text-xs font-medium rounded-full flex items-center gap-1">
                            <i className="ri-time-line"></i>
                            {article.readTime}
                          </span>
                        </div>
                      </div>
                      
                      <div className="p-6 flex-1 flex flex-col">
                        <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors line-clamp-2 leading-tight">
                          {article.title}
                        </h3>
                        
                        <p className="text-gray-600 mb-4 line-clamp-3 text-sm flex-1 leading-relaxed">
                          {article.excerpt}
                        </p>
                        
                        <div className="space-y-4">
                          <div className="flex flex-wrap gap-2">
                            {article.tags && article.tags.slice(0, 3).map((tag, index) => (
                              <span
                                key={index}
                                className="px-3 py-1 bg-teal-50 text-teal-700 text-xs rounded-full hover:bg-teal-100 transition-colors font-medium"
                              >
                                #{tag}
                              </span>
                            ))}
                          </div>
                          
                          <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                            <span className="text-teal-600 font-bold text-sm group-hover:gap-2 flex items-center gap-1 transition-all whitespace-nowrap">
                              閱讀全文 <i className="ri-arrow-right-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </>
          ) : (
            <div className="text-center py-20 bg-gradient-to-br from-gray-50 to-teal-50 rounded-3xl border-2 border-dashed border-gray-300">
              <div className="w-32 h-32 mx-auto mb-6 bg-gradient-to-br from-teal-100 to-emerald-100 rounded-full flex items-center justify-center">
                <i className="ri-search-line text-6xl text-teal-600"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">找不到相關文章</h3>
              <p className="text-gray-600 mb-8 text-lg max-w-md mx-auto">
                {searchQuery ? `沒有找到與「${searchQuery}」相關的文章，試試其他關鍵字` : '此分類暫無文章'}
              </p>
              <button
                onClick={() => {
                  setSearchQuery('');
                  setSelectedCategory('all');
                }}
                className="px-8 py-3 bg-gradient-to-r from-teal-600 to-emerald-600 text-white rounded-full font-bold hover:shadow-2xl transition-all cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
              >
                <i className="ri-home-line"></i>
                查看所有文章
              </button>
            </div>
          )}
        </div>

        {/* CTA 區塊 - 使用青綠色系 */}
        <div className="mt-20 bg-gradient-to-br from-teal-600 via-emerald-600 to-teal-700 rounded-3xl p-12 text-center text-white relative overflow-hidden shadow-2xl">
          <div className="absolute inset-0 bg-black/10"></div>
          <div className="absolute top-0 left-0 w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>
          
          <div className="relative">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-6">
              <i className="ri-customer-service-line text-xl"></i>
              <span className="font-medium">專業搬家服務</span>
            </div>
            
            <h2 className="text-4xl font-bold mb-4">需要專業搬家服務？</h2>
            <p className="text-xl mb-8 text-white/90 max-w-2xl mx-auto">
              10年經驗，5000+成功案例，讓我們為您提供最專業的搬家服務
            </p>
            
            <div className="flex flex-wrap gap-4 justify-center mb-8">
              <a
                href="tel:0978-900-081"
                className="px-8 py-4 bg-white text-teal-600 rounded-full font-bold text-lg hover:shadow-2xl transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 hover:scale-105"
              >
                <i className="ri-phone-line text-xl"></i>
                立即來電：0978-900-081
              </a>
              <Link
                to="/quote"
                className="px-8 py-4 bg-white/20 backdrop-blur-sm text-white border-2 border-white rounded-full font-bold text-lg hover:bg-white hover:text-teal-600 transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 hover:scale-105"
              >
                <i className="ri-file-list-line text-xl"></i>
                線上免費估價
              </Link>
            </div>
            
            <div className="flex flex-wrap gap-6 justify-center text-sm">
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-xl"></i>
                <span>全程保險保障</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-time-line text-xl"></i>
                <span>24小時服務</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-price-tag-3-line text-xl"></i>
                <span>透明收費</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-star-line text-xl"></i>
                <span>98%滿意度</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default KnowledgePage;